import type {ReactElement} from 'react';
import React from 'react';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize} from '@Components/text';
import {useGetNumberOfPages} from '@Hooks/poster-editor/useGetNumberOfPages';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {useGetCurrentPageNumber} from '@Hooks/poster-editor/useGetCurrentPageNumber';
import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';
import {useAppSelector} from '@/hooks';

export function SwitchPagesOption(): ReactElement | null {
  const numPages = useGetNumberOfPages();
  const currentPageNumber = useGetCurrentPageNumber();
  const pageOrder = useAppSelector((state) => {
    return state.posterEditor.posterObject?.pages.pageOrder ?? [];
  });

  if (numPages <= 1) {
    return null;
  }

  const scrollToPage = (index: number): void => {
    const whiteboardContainer = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.WHITEBOARD_CONTAINER]?.get(0);
    if (!whiteboardContainer) {
      return;
    }

    if (index >= pageOrder.length) {
      return;
    }

    const pageIdToScrollTo = pageOrder[index];
    const targetDiv = $(whiteboardContainer).find(`div.pmw-page-container[data-id="${pageIdToScrollTo}"]`);
    if (!targetDiv.length) return;

    const container = $(whiteboardContainer);
    const containerTop = container.offset()?.top ?? 0;
    const targetTop = targetDiv.offset()?.top ?? 0;
    const relativeOffset = targetTop - containerTop;

    container.animate(
      {
        scrollTop: (container.scrollTop() ?? 0) + relativeOffset,
      },
      {
        duration: 500,
        easing: 'swing',
      }
    );
  };

  return (
    <div className="_full-width flexbox flex-row-justify-center flex-items-center">
      <Icon
        onClick={(): void => {
          scrollToPage(currentPageNumber - 2);
        }}
        isDisabled={currentPageNumber === 1}
        size={IconSize.SIZE_ICON_16}
        shape={IconShape.SQUARE}
        type={IconType.GHOST}
        icon="icon-arrow-left"
        className="spacing-m-r-2"
      />
      <Text bold size={TextSize.XXSMALL} val={`${currentPageNumber} / ${numPages}`} />
      <Icon
        onClick={(): void => {
          scrollToPage(currentPageNumber);
        }}
        isDisabled={currentPageNumber === numPages}
        size={IconSize.SIZE_ICON_16}
        shape={IconShape.SQUARE}
        type={IconType.GHOST}
        icon="icon-arrow-right"
        className="spacing-m-l-2"
      />
    </div>
  );
}
